import { ArrowUpRight } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";

const socialLinks = [
  { Icon: TwitterIcon, href: "https://x.com/Softlume_in", label: "Twitter" },
  {
    Icon: InstagramIcon,
    href: "https://www.instagram.com/softlume.in?igsh=cGo0ODl0NXc1enoy&utm_source=qr",
    label: "Instagram",
  },
  {
    Icon: LinkedInIcon,
    href: "https://linkedin.com/company/softlume",
    label: "LinkedIn",
  },
  {
    Icon: FacebookIcon,
    href: "https://facebook.com/softlume",
    label: "Facebook",
  },
];

const footerLinks = {
  Services: [
    { label: "Web Development", route: "/services" },
    { label: "Mobile Apps", route: "/services" },
    { label: "Custom Software", route: "/services" },
    { label: "Cloud Solutions", route: "/services" },
  ],
  Company: [
    { label: "About Us", route: "/about" },
    { label: "Portfolio", route: "/portfolio" },
    { label: "Testimonials", route: "/testimonials" },
    { label: "Contact", route: "/contact" },
  ],
  Resources: [
    { label: "Case Studies", route: "/case-studies" },
    { label: "Privacy Policy", route: "/privacy-policy" },
    { label: "Terms of Service", route: "/terms-of-service" },
  ],
};

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const goTop = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return (
    <footer
      data-testid="footer-section"
      className="relative bg-slate-950 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          <div className="lg:col-span-2">
            <button
              onClick={goTop}
              className="flex items-center gap-2 mb-4 group"
            >
              <img
                src="/logo.png"
                alt="Softlume Logo"
                className="h-16 w-auto group-hover:drop-shadow-[0_0_15px_rgba(59,130,246,0.5)] transition-all duration-300"
              />
              {/* <span className="font-heading font-bold text-xl text-white tracking-tight">
                Soft<span className="text-blue-400">lume</span>
              </span> */}
            </button>
            <p className="text-sm text-slate-400 leading-relaxed max-w-sm mb-6">
              Illuminating Digital Futures. We blend technical precision with
              creative innovation to build software that matters.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  data-testid={`footer-social-${i}`}
                  className="w-9 h-9 rounded-lg bg-white/5 border border-white/5 flex items-center justify-center text-slate-400 hover:text-white hover:border-blue-500/30 hover:bg-blue-500/10 transition-all duration-300"
                >
                  <social.Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading font-semibold text-sm text-white mb-4 tracking-wide uppercase">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => navigate(link.route)}
                      className="text-sm text-slate-500 hover:text-slate-300 transition-colors duration-200"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-600">
            &copy; {new Date().getFullYear()} Softlume. All rights reserved.
          </p>
          <button
            data-testid="footer-back-to-top"
            onClick={goTop}
            className="flex items-center gap-1.5 text-xs text-slate-500 hover:text-blue-400 transition-colors"
          >
            Back to top <ArrowUpRight className="w-3 h-3" />
          </button>
        </div>
      </div>
    </footer>
  );
}
